import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useChatContext } from 'stream-chat-react';
import { RootState } from '../../store';
import { initializeClientAction } from '../../store/messages/actions';

export const useChatClient = () => {
  const dispatch = useDispatch();
  const { client: chatClient } = useChatContext();
  const clientInitialized = useSelector(
    (state: RootState) => state.messages.clientInitialized,
  );

  useEffect(() => {
    dispatch(initializeClientAction(chatClient));
  }, [chatClient]);

  return clientInitialized ? chatClient : null;
};
